import React from 'react';
import {TableContext} from '../Table/TableContext';

export interface TableCellProps extends React.TdHTMLAttributes<HTMLTableDataCellElement> {}

/** @component */
export const TableCellBase: React.FunctionComponent<TableCellProps> = props => (
    <TableContext.Consumer>
        {({variant}) => {
            const TableCellComponent = variant === 'head' ? 'th' : 'td';

            return <TableCellComponent {...props} />;
        }}
    </TableContext.Consumer>
);
